import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087705@2x.png";
import safeIcon from "@assets/icons/safeIcon.svg";
import {
  HeroSection,
  ResidentialTariffsSection,
  StandardFeesSection,
  SecurityDepositSection,
  CorrectionFactorsSection,
  MinimumChargesSection,
  TaxesComplianceSection,
  EmergencyCTASection,
} from "../../components";

export function Tariffs() {
  return (
    <div className="w-full flex flex-col items-start justify-center bg-white">
      <HeroSection
        title="Transparent Tariffs, Certified Fair Pricing, and No Hidden Fees."
        description="At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), we believe in full transparency. Our tariffs reflect international LPG market benchmarks, UAE regulatory standards and certified safety and service quality."
        heroImage={heroImage}
        badgeIcon={<img src={safeIcon} alt="" className="w-7 h-7" />}
      />
      <ResidentialTariffsSection />
      <StandardFeesSection />
      <SecurityDepositSection />
      <CorrectionFactorsSection />
      <MinimumChargesSection />
      <TaxesComplianceSection />
      <EmergencyCTASection
        title="Need Help Understanding Your Tariff?"
        subtitle={
          <>
            Contact our team for a detailed breakdown or to request a quotation.
          </>
        }
      >
        <div className="flex shrink-0 flex-col items-start">
          <div className="rounded-[12px] md:rounded-[24px] bg-white p-3 md:p-6 space-y-2.5">
            <div className="flex items-center gap-2">
              <span className="text-[14px] md:text-xs font-medium text-[#1c1c1c] md:text-nowrap">
                800-GAZ (42747)
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-[14px] md:text-xs font-medium text-[#1c1c1c] md:text-nowrap">
                info@gazglobal.net
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-[14px] md:text-xs font-medium text-[#1c1c1c] md:text-nowrap">
                Available 24/7
              </span>
            </div>
          </div>
        </div>
      </EmergencyCTASection>
      <Footer />
    </div>
  );
}

export default Tariffs;
